import { useCartState } from "src/checkout/hooks/useCart"
import { CheckoutStep, setCheckoutStep } from "src/checkout/state/checkoutStageStore"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { setCartSidebarVisible } from "src/components/np-design/sections/cart-sidebar/state"
import { routes } from "src/config/routes"
import { formatPriceLong } from "src/utilities/price"

export const GoToCheckoutButton = () => {
  const { data: cart } = useCartState()

  const total = +(cart?.totals.total_price || 0) / 100

  return (
    <NpButton
      href={routes.checkout}
      onClick={() => {
        setCheckoutStep(CheckoutStep.ShippingInfo)
        setCartSidebarVisible(false)
      }}
    >
      Sicher zur Kasse | {formatPriceLong(total)}
    </NpButton>
  )
}
